import { POPUP_SECTIONS } from "../../constant/constant.js";

/**
 * @param {object[]} sections
 */
export function indexAiRecommendationUpsellSections(sections = []) {
  const list = Array.isArray(sections) ? sections : [];
  /** @type {Record<string, { section: object, index: number }>} */
  const byRole = {};
  /** @type {{ section: object, index: number }[]} */
  const buttons = [];

  list.forEach((section, index) => {
    const role = section?.setting?.role;
    if (role) {
      byRole[role] = { section, index };
    }
    if (section?.type === POPUP_SECTIONS.BUTTON) {
      buttons.push({ section, index });
    }
  });

  const findByType = (type) => {
    const index = list.findIndex((s) => s?.type === type);
    if (index < 0) return null;
    return { section: list[index], index };
  };

  return {
    sections: list,
    byRole,
    urgency: byRole.urgency || null,
    countdown: findByType(POPUP_SECTIONS.COUNTDOWN),
    aiBanner: byRole.aiBanner || null,
    product: findByType(POPUP_SECTIONS.PRODUCT),
    socialProof:
      findByType(POPUP_SECTIONS.SOCIAL_PROOF) || byRole.socialProof || null,
    trust:
      findByType(POPUP_SECTIONS.TRUST_BADGES) || byRole.trust || null,
    brandAttribution:
      findByType(POPUP_SECTIONS.BRAND_ATTRIBUTION) ||
      byRole.brandAttribution ||
      byRole.footer ||
      null,
    /** @deprecated use brandAttribution */
    footer:
      findByType(POPUP_SECTIONS.BRAND_ATTRIBUTION) ||
      byRole.brandAttribution ||
      byRole.footer ||
      null,
    primaryCta:
      byRole.primaryCta || buttons.find((b) => b.section?.setting?.role === "primaryCta") || buttons[0] || null,
    secondaryCta:
      byRole.secondaryCta ||
      buttons.find((b) => b.section?.setting?.role === "secondaryCta") ||
      buttons[1] ||
      null,
  };
}

import { mergeAiRecommendationUpsellOptions } from "./aiRecommendationUpsellDefaults.js";

/**
 * @param {object | null | undefined} popupData
 */
export function getAiRecommendationUpsellLayoutOptions(popupData) {
  const gs = popupData?.generalSettings || {};
  const raw = gs.layoutConfig?.options || gs.layoutTree?.options || {};
  return mergeAiRecommendationUpsellOptions(raw);
}
